import Http from "./http";

export const updateTermsAndConditionsAPI = (payload) => {
  return Http.post("admin/campaign/terms-condition/update", payload);
};

